import { getDisplayName, logout, PREVIEW_MODE } from "./keycloak";

export function renderChrome(activeNav: "dashboard" | "upload"): void {
  const header = document.getElementById("app-header");
  if (!header) return;

  const navItem = (id: typeof activeNav, label: string, href: string): string => `
    <a href="${href}" class="text-sm px-3 py-2 rounded transition-colors ${
      activeNav === id ? "text-tfg" : "text-bone-muted hover:text-bone"
    }">${label}</a>
  `;

  header.innerHTML = `
    ${PREVIEW_MODE ? renderPreviewBanner() : ""}
    <div class="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
      <div class="flex items-center gap-8">
        <a href="/" class="flex items-center gap-3 text-bone" aria-label="Twenty First Group · pitch">
          <img src="/tfg-logo.svg" alt="Twenty First Group" class="h-9 w-auto text-bone" />
          <span class="h-6 w-px bg-ink-border" aria-hidden="true"></span>
          <span class="text-bone font-semibold text-sm tracking-tight uppercase">pitch</span>
        </a>
        <nav class="flex items-center gap-1">
          ${navItem("dashboard", "Dashboard", "/")}
          ${navItem("upload", "New report", "/upload.html")}
        </nav>
      </div>
      <div class="flex items-center gap-3">
        <span class="text-xs text-bone-muted font-mono">${escapeHtml(getDisplayName())}</span>
        ${
          PREVIEW_MODE
            ? ""
            : `
          <button id="logout-btn" class="text-xs text-bone-muted hover:text-bone underline-offset-4 hover:underline">
            Sign out
          </button>
        `
        }
      </div>
    </div>
  `;

  if (!PREVIEW_MODE) {
    document.getElementById("logout-btn")?.addEventListener("click", () => logout());
  }
}

function renderPreviewBanner(): string {
  return `
    <div class="bg-gold-subtle border-b border-gold/40 text-gold text-xs">
      <div class="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
        <span>
          <span class="font-semibold uppercase tracking-wider">Preview mode</span>
          · auth is disabled and the API is unreachable. UI shows placeholder data only.
        </span>
        <span class="font-mono text-bone-muted">${escapeHtml(import.meta.env.VITE_BUILD_REF ?? "dev")}</span>
      </div>
    </div>
  `;
}

export function escapeHtml(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
